import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    color: "#243E81",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 22.5C18.299 22.5 23 17.799 23 12S18.299 1.5 12.5 1.5 2 6.201 2 12s4.701 10.5 10.5 10.5m0 1.5c6.627 0 12-5.373 12-12s-5.373-12-12-12S.5 5.373.5 12s5.373 12 12 12" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 5.5a.75.75 0 0 0-1.5 0v5.75H6a.75.75 0 0 0 0 1.5h5.75v5.75a.75.75 0 0 0 1.5 0v-5.75H19a.75.75 0 0 0 0-1.5h-5.75z" fill="currentColor"/>' }
  })
);